import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//data inicial
const dataInicial = {
    data: {},
    fc_41: {
        fechasolicitud: fechaHoy,
        numerocliente: '',
        resposableinstalacion: '',
        correoelectronico: '',
        telefono: '',
        estado: '',
        municipioalcaldia: '',
        codigopostal: '',
        colonia: '',
        localidad: '',
        otracalle: '',
        calle: '',
        numeroexterior: '',
        numerointerior: '',
        entregahologramasbebidasmezcal: false,
        emicioncertificadonomexportacio: false,
        inspeccionduranteenvasado: false,
        emicioncertificadonomnacional: false,
        fechavisitapropuesta: fechaHoy,
        nombre: '',
        domicilio: '',
        paisdestino: '',
        aduanasalida: '',
        observaciones: '',
        ventaexportacion: false,
        ventanacional: false,
    },
    loading: false,
    productos: [],
    fc_41Map: {},
    productosMap: [],
    paginaActiva: 1,
    modoEdicionBorrador: false,
    modoCorreccion: false,
    cliente: [],
    instalacionesCliente: [],
    dataLogin: [],
    marcas: [],
    filesProductos: [],
    filesProductosMap: []
}

//types
const OBTENER_FC_41_DETALLE_EXITO = 'OBTENER_FC_41_DETALLE_EXITO'
const OBTENER_FC_41_MAP_EXITO = 'OBTENER_FC_41_MAP_EXITO'
const FC_41_SOLICITUD_EXITO = 'FC_41_SOLICITUD_EXITO'
const AGREGAR_FC_41_BORRADOR_EXITO = 'AGREGAR_FC_41_BORRADOR_EXITO'
const ACTUALIZAR_FC_41_ESTATUS_EXITO = 'ACTUALIZAR_FC_41_ESTATUS_EXITO'
const ELIMINAR_FC_41_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_41_SOLICITUD_EXITO_BD'
const ELIMINAR_FC_41_ANEXOPRODUCTO_EXITO_BD = 'ELIMINAR_FC_41_ANEXOPRODUCTO_EXITO_BD'
const OBTENER_CLIENTE_POR_LOGIN_EXITO_41 = 'OBTENER_CLIENTE_POR_LOGIN_EXITO_41'
const OBTENER_FC_41_CONTADOR_FECHA_FOLIO_EXITO = 'OBTENER_FC_41_CONTADOR_FECHA_FOLIO_EXITO'
const ACTUALIZAR_FC_41_BORRADOR_EXITO = 'ACTUALIZAR_FC_41_BORRADOR_EXITO'
const AGREGAR_ARCHIVO_FC_41_EXITO = 'AGREGAR_ARCHIVO_FC_41_EXITO'
const ACTUALIZAR_ARCHIVO_FC_41_EXITO = 'ACTUALIZAR_ARCHIVO_FC_41_EXITO'


export const ObtenerClientePorLogin41 = createAsyncThunk(
    OBTENER_CLIENTE_POR_LOGIN_EXITO_41,
    async (params) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorLogin/${params.idlogin}`

            const res = await axios.get(fullUrl)
            let idcliente = res.data.data.idcliente
            let idcartera = res.data.data.idcartera
            const fullUrlInstalaciones = host + `InformacionValida/obtenerTodosAnexosCliente/${idcliente}`
            const fullUrlDatosLogin = host + `AnexoUsuario/obtenerDatosLoginPorCartera/${idcartera}`
            const fullUrlDomicilioCliente = host + `InformacionValida/obtenerDomicilioFiscalClientePorCliente/${idcliente}`

            const resinstalaciones = await axios.get(fullUrlInstalaciones)
            const resdomicilio = await axios.get(fullUrlDomicilioCliente)
            let datos = []
            let instalaciones = []
            let marcas = []

            //marcas.push()
            /*for (const i in res.data.data.marcascliente) {
                if (res.data.data.marcascliente[i].isbaja == false) marcas.push(res.data.data.marcascliente[i])
            }*/
            for (const i in res.data.data.marcasproductoconmezcalcliente) {
                if (res.data.data.marcasproductoconmezcalcliente[i].isbaja == false) 
                marcas.push(res.data.data.marcasproductoconmezcalcliente[i])
            }
            let envasadoras = []
            for (const i in resinstalaciones?.data?.data) {
                if (resinstalaciones?.data?.data?.[i].idtipoanexo == 2) {
                    envasadoras.push(resinstalaciones.data.data[i])
                }
            }
            instalaciones.push(envasadoras)
            const resdatoslogin = await axios.get(fullUrlDatosLogin)
            let datosLogin = []
            datosLogin.push(resdatoslogin.data.data)
            datos.push(res.data.data, instalaciones, datosLogin, marcas)
            return datos
        } catch (error) {
            console.log(error);
        }
    }
)
export const registrarSolicitudFC_41Accion = createAsyncThunk(
    FC_41_SOLICITUD_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = data.productos

            const agregarFC_41 = host + 'FC_41/agregarFormatoFC41'
            const urlAnexoProductos = host + 'FC_41/agregarFormatoFC41_AnexoProducto'

            const res = await axios.post(agregarFC_41, solicitud)
            let idfc41_solicitudparabebidasconm = res.data.data.idfc41_solicitudparabebidasconm

            for (let i in productos) {
                const { id, ...anexo } = productos[i]
                anexo.contenidoalcoholico = anexo.contenidoalcoholico + ''
                anexo.idfc41_solicitudparabebidasconm = idfc41_solicitudparabebidasconm
                await axios.post(urlAnexoProductos, { data: anexo })
            }

            return { data: res.data.data }
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerContadorDeFechaFolio = createAsyncThunk(
    OBTENER_FC_41_CONTADOR_FECHA_FOLIO_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Estatus/ContadorGeneralDeFechasFolio/year=${year}`
            const res = await axios.get(fullUrl)
            const contador =
                res.data.data.resultfc_01[0].count + res.data.data.resultfc_05[0].count + res.data.data.resultfc_06[0].count +
                res.data.data.resultfc_08[0].count + res.data.data.resultfc_09[0].count + res.data.data.resultfc_30[0].count +
                res.data.data.resultfc_31[0].count + res.data.data.resultfc_33[0].count + res.data.data.resultfc_34[0].count +
                res.data.data.resultfc_35[0].count + res.data.data.resultfc_36[0].count + res.data.data.resultfc_40[0].count +
                res.data.data.resultfc_41[0].count
            return contador
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_41SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_41_DETALLE_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_41/obtenerFormatoFC41_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)

            let fc_41_anexoproducto = []
            const documentosProductos = []
            for (let i in res.data.data.fc_41_anexoproducto) {
                res.data.data.fc_41_anexoproducto[i]['id'] = uuidv4()
                for (const j in res.data.data.fc_41_anexoproducto[i].fc_41archivoproducto) {
                    const { ...anexo } = res.data.data.fc_41_anexoproducto[i].fc_41archivoproducto[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_41archivoproducto,
                        idAnexoFK: res.data.data.fc_41_anexoproducto[i].idfc33_anexoproducto,
                        estatus: true,
                    }

                    documentosProductos.push(data)
                }
            }
            fc_41_anexoproducto.push({ data: res.data.data.fc_41_anexoproducto })
            if (res.data.data.fechavisitapropuesta) {
                let fecha = res.data.data.fechavisitapropuesta
                res.data.data.fechavisitapropuesta = moment(fecha).add(1, 'd').format('YYYY-MM-DD')
            }
            return { data: res.data.data, fc_41_anexoproducto, documentosProductos }
        } catch (error) {
            console.log(error);
        }
    }
)
const getNameFile = async (ruta) => {
    let nameFile = null
    const array = ruta.split("/")
    // const array = ruta.split("\\")//local
    nameFile = array[array.length - 1]
    return nameFile
}
export const actualizarFC_41Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_41_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = data.productos

            const actualizarFC_41 = host + `FC_41/actualizarFormatoFC41`
            const urlAgregarAnexoProductos = host + 'FC_41/agregarFormatoFC41_AnexoProducto'
            const urlActualizarAnexoProductos = host + 'FC_41/actualizarFormatoFC41_AnexoProducto'

            const res = await axios.put(actualizarFC_41, solicitud)
            let idfc41_solicitudparabebidasconm = res.data.data.idfc41_solicitudparabebidasconm
            for (let i in productos) {
                const { id, fc_41archivoproducto, ...anexo } = productos[i]
                if (anexo.idfc41_anexoproducto) {
                    const result = await axios.put(urlActualizarAnexoProductos, { data: anexo })
                } else {
                    anexo.idfc41_solicitudparabebidasconm = idfc41_solicitudparabebidasconm
                    await axios.post(urlAgregarAnexoProductos, { data: anexo })
                }
            }
            return data
        } catch (error) {
            console.log(error)
        }
    }
)
export const eliminarFC_41AnexoProductoBD = createAsyncThunk(
    ELIMINAR_FC_41_ANEXOPRODUCTO_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_41/eliminarFormatoFC41_AnexoProducto/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)
export const agregarFileFC_41 = createAsyncThunk(
    AGREGAR_ARCHIVO_FC_41_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await agregarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const agregarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexoFK)
    const resFile = await axios.post(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const actualizarFileFC_41 = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_FC_41_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const eliminarFC_41SolicitudBD = createAsyncThunk(
    ELIMINAR_FC_41_SOLICITUD_EXITO_BD,
    async (id) => {
        try {
            const fullUrlSolicitud = host + `FC_41/eliminarFormatoFC41/${id}`
            const resultDelete = await axios.delete(fullUrlSolicitud)
            return { id }
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_41Estatus = createAsyncThunk(
    ACTUALIZAR_FC_41_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerFC_41Map = createAsyncThunk(
    OBTENER_FC_41_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_41_SolicitudParaBebidasConMezcalMap/${solicitudId}`
            const res = await axios.get(fullUrl)

            const productosMap = await obtenerProductosMap(solicitudId)
            console.log("los datos de productos es ", productosMap)
            const solicitudMap = {
                data: res.data.data,
                productosMap: productosMap.productosMap,
                filesProductosMap: productosMap.filesProductosMap
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)

const obtenerProductosMap = async (idSolicitud) => {

    try {
        const fullUrl = host + `FC_41/obtenerFormatoFC41_ConDetalle/${idSolicitud}`
        const obtenerProductoMap = host + `MapSolicitud/obtenerMapFC_41_AnexoCaracteristicasProductoMap/`
        const obtenerFilesProductoMap = host + `MapSolicitud/obtenerMapFC_41_ArchivosProductos/`

        const res = await axios.get(fullUrl)
        let anexoProductoMap = []
        const fc_41_anexoproducto = res.data.data.fc_41_anexoproducto

        for (const anexo of fc_41_anexoproducto) {
            const resMap = await axios.get(obtenerProductoMap + anexo.idfc41_anexoproducto)
            anexoProductoMap.push(resMap.data.data)

        }
        let filesArchivosMap = []
        for (const producto of fc_41_anexoproducto) {
            for (const archivo of producto.fc_41archivoproducto) {
                const resfiles = await axios.get(obtenerFilesProductoMap + archivo.idfc_41archivoproducto)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_41archivoproducto
                    filesArchivosMap.push(resfiles.data.data)
                }
            }
        }


        return { productosMap: anexoProductoMap, filesProductosMap: filesArchivosMap }
    } catch (error) {
        console.log(error);
    }
}

























































export const agregarFC_41SolicitudBorrador = createAsyncThunk(
    AGREGAR_FC_41_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = { data: data.productosAGuardar }

            const agregarFC_41 = host + 'FC_41/agregarFormatoFC41'
            const urlAnexoProductos = host + 'FC_41/agregarFormatoFC41AnexoCaracteristicasProducto'

            const res = await axios.post(agregarFC_41, solicitud)

            let idfc41_solicitudparabebidasconm = res.data.data.idfc41_solicitudparabebidasconm

            for (const anexo of productos.data) {
                anexo.idfc41_solicitudparabebidasconm = idfc41_solicitudparabebidasconm
                await axios.post(urlAnexoProductos, { data: anexo })
            }

            return {
                solicitud,
                productos
            }
        } catch (error) {
            console.log(error)
        }
    }
)

export const fc41Slice = createSlice({
    name: 'fc41Slice',
    initialState: dataInicial,
    reducers: {
        guardarCambiosFC_41SolicitudBorrador(state, { payload }) {
            state.data = payload
        },
        guardarCambiosFC_41SolicitudNueva(state, { payload }) {
            state.fc_41 = payload
        },
        agregarFC_41AnexoProducto(state, { payload }) {
            state.productos = payload
        },
        agregarFC_41Producto(state, { payload }) {
            state.productos.data.push(payload)
        },
        actualizarModoBorradorFC_41(state, { payload }) {
            state.modoEdicionBorrador = payload
        },
        actualizarModoCorrecionFC_41(state, { payload }) {
            state.modoCorreccion = payload
        },
        actualizarFC_41PaginaActiva(state, { payload }) {
            state.paginaActiva = payload
        },
        editarFC_41AnexoProductoBeneficiario(state, { payload }) {
            const input = state.productos.data.filter(field => field.id === payload.id)
            if (input.length > 0) {
                input[0][payload.campo] = payload.valor
            }
        },
        resetDataFC_41(state, { payload }) {
            return dataInicial
        },
    },
    extraReducers: {
        [ObtenerClientePorLogin41.fulfilled]: (state, { payload }) => {
            console.log("los que llega payload es ", payload)
            state.cliente = payload[0]
            state.instalacionesCliente = payload[1][0]
            state.dataLogin = payload[2][0][0]
            state.marcas = payload[3]
        },
        [obtenerFC_41SolicitudDetalle.fulfilled]: (state, { payload }) => {
            state.data = payload.data
            state.fc_41 = payload.data
            state.dataDocumentacion = payload.data
            state.productos = { data: payload.data.fc_41_anexoproducto }
            state.filesProductos = { data: payload.documentosProductos }

        },
        [obtenerFC_41Map.fulfilled]: (state, { payload }) => {
            state.fc_41Map = payload.data
            state.productosMap = payload.productosMap
            state.filesProductosMap = payload.filesProductosMap
        },
        [registrarSolicitudFC_41Accion.fulfilled]: (state, { payload }) => {
        },
        [agregarFC_41SolicitudBorrador.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_41Estatus.fulfilled]: (state, { payload }) => {
        },
        [eliminarFC_41SolicitudBD.fulfilled]: (state, { payload }) => {
        },
        [eliminarFC_41AnexoProductoBD.fulfilled]: (state, { payload }) => {

        }
    },
})

//actions
export const {
    agregarFC_41AnexoProducto,
    agregarFC_41Producto,
    guardarCambiosFC_41SolicitudBorrador,
    guardarCambiosFC_41SolicitudNueva,
    actualizarModoBorradorFC_41,
    actualizarModoCorrecionFC_41,
    actualizarFC_41PaginaActiva,
    editarFC_41AnexoProductoBeneficiario,
    resetDataFC_41,
} = fc41Slice.actions

export const FC41ReducerBeneficiario = fc41Slice.reducer